import { useCallback } from "react";
import { useAuthContext } from "../../_helper/Auth";
import axios from "../../api/axios";

export function useRefreshCurrentUser() {
  const { addUser } = useAuthContext();

  return useCallback(async () => {
    const token = localStorage.getItem("access_token");
    if (!token) return;

    try {
      const { data } = await axios.get("me", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const userData = data?.data?.user ?? data?.user ?? data?.data ?? data;
      if (userData?.all_permissions) {
        addUser(userData);
      }
    } catch (err) {
      console.error("Failed to refresh current user permissions:", err);
    }
  }, [addUser]);
}
